import { Stack } from '@mui/material';
import type { Provider } from '@repo/api-gw-sdk';

import { KmsCopyablePolicy } from './kmsCopyablePolicy';
import { KmsEditKeyPolicyButton } from './kmsEditKeyPolicyButton';

export const KmsSuggestedPolicyContent = ({
  kmsKey,
  cloudProvider,
  withRestoreAccounts = true,
}: {
  kmsKey?: string;
  cloudProvider: Provider;
  withRestoreAccounts?: boolean;
}) => {
  return (
    <Stack paddingX='40px' gap='24px' alignItems='flex-end'>
      <KmsCopyablePolicy
        cloudProvider={cloudProvider}
        withRestoreAccounts={withRestoreAccounts}
      />
      <KmsEditKeyPolicyButton kmsKey={kmsKey} />
    </Stack>
  );
};
